import alertSlice, { alertsAdapter } from "./alertSlice";
import { createSelector } from "@reduxjs/toolkit";

export const selectAlertSlice = (state) => state[alertSlice.name];

const alertsAdapterSelectors = alertsAdapter.getSelectors(selectAlertSlice);
const selectAllAlerts = alertsAdapterSelectors.selectAll;

export const selectAllAlertsSorted = createSelector(
  selectAllAlerts,
  (alerts) => alerts.sort((a, b) => a.id - b.id)
);